/**
 * DH Brew Waitlist — Form submission to Klaviyo Subscribe API
 * Handles both above-fold and below-fold forms, syncs success state.
 */
(function () {
  const SECTION_SEL = '.dh-bw';
  const FORM_SEL = '.dh-bw__form';
  const INPUT_SEL = '.dh-bw__input';
  const BTN_SEL = '.dh-bw__btn';
  const ERROR_SEL = '.dh-bw__error';
  const SUCCESS_SEL = '.dh-bw__success';
  const ERROR_VISIBLE = 'dh-bw__error--visible';
  const INPUT_ERROR = 'dh-bw__input--error';

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init() {
    const section = document.querySelector(SECTION_SEL);
    if (!section) return;

    const companyId = section.dataset.klaviyoCompanyId;
    const listId = section.dataset.klaviyoListId;
    if (!companyId || !listId) return;

    const forms = section.querySelectorAll(FORM_SEL);
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        handleSubmit(form, companyId, listId, section);
      });
    });
  }

  function handleSubmit(form, companyId, listId, section) {
    var input = form.querySelector(INPUT_SEL);
    var btn = form.querySelector(BTN_SEL);
    var errorEl = form.parentNode.querySelector(ERROR_SEL);
    var email = input.value.trim();

    clearError(input, errorEl);

    if (!email || !EMAIL_RE.test(email)) {
      showError(input, errorEl, 'Please enter a valid email address.');
      input.focus();
      return;
    }

    btn.disabled = true;

    subscribeToKlaviyo(companyId, listId, email)
      .then(function () {
        showAllSuccess(section);
      })
      .catch(function () {
        btn.disabled = false;
        showError(input, errorEl, 'Something went wrong. Please try again.');
      });
  }

  function subscribeToKlaviyo(companyId, listId, email) {
    var url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

    var formData = new FormData();
    formData.append('g', listId);
    formData.append('email', email);
    formData.append('$fields', '$source,$signup_page_url');
    formData.append('$source', 'brew-waitlist');
    formData.append('$signup_page_url', window.location.href);

    return fetch(url, {
      method: 'POST',
      body: formData
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Klaviyo subscription failed');
      }
      return response.json();
    }).then(function (data) {
      if (data && data.errors && data.errors.length > 0) {
        throw new Error(data.errors[0]);
      }
    });
  }

  function showAllSuccess(section) {
    var formWraps = section.querySelectorAll('.dh-bw__form-wrap');
    formWraps.forEach(function (wrap) {
      var form = wrap.querySelector(FORM_SEL);
      var success = wrap.querySelector(SUCCESS_SEL);
      if (form) form.setAttribute('aria-hidden', 'true');
      if (success) success.setAttribute('aria-hidden', 'false');
    });
  }

  function showError(input, errorEl, msg) {
    input.classList.add(INPUT_ERROR);
    if (errorEl) {
      errorEl.textContent = msg;
      errorEl.classList.add(ERROR_VISIBLE);
    }
  }

  function clearError(input, errorEl) {
    input.classList.remove(INPUT_ERROR);
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.classList.remove(ERROR_VISIBLE);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
